<div class="auth-flex-container">
  <div class="form-wrapper">
    <div class="form-header-wrapper">
      <h2 class="form-header-text">Log in to your Summit account.</h2>
      <div>
        <span class="form-header--login-text">Need a Login?</span>&nbsp;<span class="router-link" (click)="goToUserProfileNew()">Request now</span>
      </div>
    </div>
    <form [formGroup]="authForm" class="form--form-element">
      <div [hidden]="verificationResult === 'VERIFY' || !failedAttempt">
        <div [@flyInOut]="animationTrigger" class="failed-login-message-container" [ngClass]="{'warning-message': unsuccessfulLoginCounter <= 3, 'error-message': unsuccessfulLoginCounter > 3}">
          <mat-icon>error</mat-icon>&nbsp;
          @if(unsuccessfulLoginCounter < 2) {
            <span>Sorry, that username or password is incorrect. We can help you </span>
            <span class="recover-password-text"><a [routerLink]="['/forgotPassword']" [queryParams]="{email: this.authForm.controls.authUser.value}">recover your password.</a></span>
          } @else if (unsuccessfulLoginCounter == 2) {
            <span><strong>Two</strong>&nbsp;login attempts remaining. We can help you </span>
            <span class="recover-password-text"><a [routerLink]="['/forgotPassword']" [queryParams]="{email: this.authForm.controls.authUser.value}">recover your password.</a></span>
          } @else if (unsuccessfulLoginCounter == 3) {
            <span><strong>One</strong>&nbsp;login attempt remaining before account is disabled. We can help you </span>
            <span class="recover-password-text"><a [routerLink]="['/forgotPassword']" [queryParams]="{email: this.authForm.controls.authUser.value}">recover your password.</a></span>
          } @else {
            <span>For security reasons, this account is disabled for&nbsp;<b>{{remainingLockoutTime}}</b>&nbsp;seconds.&nbsp;</span>
            <span>Click&nbsp;<a [routerLink]="['/forgotPassword']" [queryParams]="{email: this.authForm.controls.authUser.value}">here</a>&nbsp;to reset your password.</span>
          }
        </div>
      </div>
      <br>
      <div class="input-wrapper">
        <div>
          <mat-form-field appearance="outline">
            <mat-label>
              <strong style="font-size: 15px;">Email</strong>
            </mat-label>
            <input matInput
                   autofocus
                   type="text"
                   id="userLogin"
                   name="userLogin"
                   autocomplete="username"
                   [readonly]="loginLoading"
                   formControlName="authUser">
            @if (authForm.controls.authUser.invalid) {
              <mat-error>{{authForm.controls.authUser.hasError('required') ? 'Username is required' : 'Not a valid email'}}</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form--password-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>
              <strong style="font-size: 15px;">Password</strong>
            </mat-label>
            <input matInput
                   id="_jpassword"
                   name="_jpassword"
                   autocomplete="current-password"
                   [type]="hide() ? 'password' : 'text'"
                   [readonly]="loginLoading"
                   formControlName="authPass">
            <div
              class="form--visibility-icon"
              matSuffix
              (click)="passwordVisibilityIconClicked($event)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide()">
              <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
            @if (authForm.controls.authPass.invalid) {
              <mat-error>{{authForm.controls.authUser.hasError('required') ? 'Password is required' : 'Not a valid password'}}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="bottom-margin forgot-password-wrapper">
        <a [routerLink]="['/forgotPassword']" [queryParams]="{email: authForm.controls.authUser.value}">Forgot password?</a>
      </div>
      <!-- Legal Info -->
      <div class="bottom-margin legal-info-wrapper">
        <span>By viewing the information on Summit's website, I agree to comply with all applicable privacy laws and to keep all proprietary information, all nonpublic personal information, and any other confidential information that I view or acquire on Summit's website, confidential. I understand that by logging in, I agree with these terms.</span>
      </div>
      <div class="buttons-wrapper">
        <div class="button-group-full-width">
          <button mat-flat-button
                  color="primary"
                  [ngClass]="{'button--loading': loginLoading}"
                  [disabled]="loginLoading || (unsuccessfulLoginCounter > 3)"
                  (click)="onSubmit()">
            <span>Log in</span>
          </button>
          <button mat-stroked-button
                  color="primary"
                  (click)="goToHomePage()">
            <span>Cancel</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
